import { render, staticRenderFns } from "./GenderSwitch.vue?vue&type=template&id=7d0fa1d0&scoped=true&"
import script from "./GenderSwitch.vue?vue&type=script&lang=js&"
export * from "./GenderSwitch.vue?vue&type=script&lang=js&"
import style0 from "./GenderSwitch.vue?vue&type=style&index=0&id=7d0fa1d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0fa1d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d0fa1d0')) {
      api.createRecord('7d0fa1d0', component.options)
    } else {
      api.reload('7d0fa1d0', component.options)
    }
    module.hot.accept("./GenderSwitch.vue?vue&type=template&id=7d0fa1d0&scoped=true&", function () {
      api.rerender('7d0fa1d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/core/GenderSwitch.vue"
export default component.exports